import { default as _400TADygqK2NnMeta } from "/codebuild/output/src2789111138/src/melembre-landing-page-v2/pages/400.vue?macro=true";
import { default as _500HLtSGtIt6JMeta } from "/codebuild/output/src2789111138/src/melembre-landing-page-v2/pages/500.vue?macro=true";
import { default as contatol8HThEd0JdMeta } from "/codebuild/output/src2789111138/src/melembre-landing-page-v2/pages/contato.vue?macro=true";
import { default as casas_45bahiaThmKLFPuTnMeta } from "/codebuild/output/src2789111138/src/melembre-landing-page-v2/pages/credor/casas-bahia.vue?macro=true";
import { default as digio6Z7E78KP2cMeta } from "/codebuild/output/src2789111138/src/melembre-landing-page-v2/pages/credor/digio.vue?macro=true";
import { default as pontofrioa9X60qyUAhMeta } from "/codebuild/output/src2789111138/src/melembre-landing-page-v2/pages/credor/pontofrio.vue?macro=true";
import { default as empresawl09WetzZLMeta } from "/codebuild/output/src2789111138/src/melembre-landing-page-v2/pages/empresa.vue?macro=true";
import { default as indexR9pb9NbRJxMeta } from "/codebuild/output/src2789111138/src/melembre-landing-page-v2/pages/index.vue?macro=true";
import { default as infoTM8JSNu1FiMeta } from "/codebuild/output/src2789111138/src/melembre-landing-page-v2/pages/info.vue?macro=true";
export default [
  {
    name: "400",
    path: "/400",
    component: () => import("/codebuild/output/src2789111138/src/melembre-landing-page-v2/pages/400.vue").then(m => m.default || m)
  },
  {
    name: "500",
    path: "/500",
    component: () => import("/codebuild/output/src2789111138/src/melembre-landing-page-v2/pages/500.vue").then(m => m.default || m)
  },
  {
    name: "contato",
    path: "/contato",
    component: () => import("/codebuild/output/src2789111138/src/melembre-landing-page-v2/pages/contato.vue").then(m => m.default || m)
  },
  {
    name: "credor-casas-bahia",
    path: "/credor/casas-bahia",
    meta: casas_45bahiaThmKLFPuTnMeta || {},
    component: () => import("/codebuild/output/src2789111138/src/melembre-landing-page-v2/pages/credor/casas-bahia.vue").then(m => m.default || m)
  },
  {
    name: "credor-digio",
    path: "/credor/digio",
    meta: digio6Z7E78KP2cMeta || {},
    component: () => import("/codebuild/output/src2789111138/src/melembre-landing-page-v2/pages/credor/digio.vue").then(m => m.default || m)
  },
  {
    name: "credor-pontofrio",
    path: "/credor/pontofrio",
    meta: pontofrioa9X60qyUAhMeta || {},
    component: () => import("/codebuild/output/src2789111138/src/melembre-landing-page-v2/pages/credor/pontofrio.vue").then(m => m.default || m)
  },
  {
    name: "empresa",
    path: "/empresa",
    component: () => import("/codebuild/output/src2789111138/src/melembre-landing-page-v2/pages/empresa.vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    meta: indexR9pb9NbRJxMeta || {},
    component: () => import("/codebuild/output/src2789111138/src/melembre-landing-page-v2/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "info",
    path: "/info",
    component: () => import("/codebuild/output/src2789111138/src/melembre-landing-page-v2/pages/info.vue").then(m => m.default || m)
  }
]